const translate_es = {
  translation: {
    countryCodes: {
      // specials
      AC: 'Isla de Ascensión',
      TA: 'Tristán de Acuña',
      XK: 'Kosovo',
      // official
      AD: 'Andorra',
      AE: 'Emiratos Árabes Unidos',
      AF: 'Afganistán',
      AG: 'Antigua y Barbuda',
      AI: 'Anguila',
      AL: 'Albania',
      AM: 'Armenia',
      AO: 'Angola',
      AQ: 'Antártida',
      AR: 'Argentina',
      AS: 'Samoa Americana',
      AT: 'Austria',
      AU: 'Australia',
      AW: 'Aruba',
      AX: 'Islas Åland',
      AZ: 'Azerbaiyán',
      BA: 'Bosnia-Herzegovina',
      BB: 'Barbados',
      BD: 'Bangladés',
      BE: 'Bélgica',
      BF: 'Burkina Faso',
      BG: 'Bulgaria',
      BH: 'Baréin',
      BI: 'Burundi',
      BJ: 'Benín',
      BL: 'San Bartolomé',
      BM: 'Bermudas',
      BN: 'Brunéi',
      BO: 'Bolivia',
      BQ: 'Bonaire, San Eustaquio y Saba',
      BR: 'Brasil',
      BS: 'Bahamas',
      BT: 'Bután',
      BV: 'Isla Bouvet',
      BW: 'Botsuana',
      BY: 'Bielorrusia',
      BZ: 'Belice',
      CA: 'Canadá',
      CC: 'Islas Cocos',
      CD: 'República Democrática del Congo',
      CF: 'República Centroafricana',
      CG: 'Congo',
      CH: 'Suiza',
      CI: 'Costa de Marfil',
      CK: 'Islas Cook',
      CL: 'Chile',
      CM: 'Camerún',
      CN: 'China',
      CO: 'Colombia',
      CR: 'Costa Rica',
      CU: 'Cuba',
      CV: 'Cabo Verde',
      CW: 'Curazao',
      CX: 'Isla de Navidad',
      CY: 'Chipre',
      CZ: 'República Checa',
      DE: 'Alemania',
      DJ: 'Yibuti',
      DK: 'Dinamarca',
      DM: 'Dominica',
      DO: 'República Dominicana',
      DZ: 'Argelia',
      EC: 'Ecuador',
      EE: 'Estonia',
      EG: 'Egipto',
      EH: 'Sáhara Occidental',
      ER: 'Eritrea',
      ES: 'España',
      ET: 'Etiopía',
      FI: 'Finlandia',
      FJ: 'Fiyi',
      FK: 'Islas Malvinas',
      FM: 'Micronesia',
      FO: 'Islas Feroe',
      FR: 'Francia',
      GA: 'Gabón',
      GB: 'Reino Unido',
      GD: 'Granada',
      GE: 'Georgia',
      GF: 'Guayana Francesa',
      GG: 'Guernsey',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GL: 'Groenlandia',
      GM: 'Gambia',
      GN: 'Guinea',
      GP: 'Guadalupe',
      GQ: 'Guinea Ecuatorial',
      GR: 'Grecia',
      GS: 'Islas Georgia del Sur y Sandwich del Sur',
      GT: 'Guatemala',
      GU: 'Guam',
      GW: 'Guinea-Bisáu',
      GY: 'Guyana',
      HK: 'Hong Kong',
      HM: 'Islas Heard y McDonald',
      HN: 'Honduras',
      HR: 'Croacia',
      HT: 'Haití',
      HU: 'Hungría',
      ID: 'Indonesia',
      IE: 'Irlanda',
      IL: 'Israel',
      IM: 'Isla de Man',
      IN: 'India',
      IO: 'Territorio Británico del Océano Índico',
      IQ: 'Irak',
      IR: 'Irán',
      IS: 'Islandia',
      IT: 'Italia',
      JE: 'Jersey',
      JM: 'Jamaica',
      JO: 'Jordania',
      JP: 'Japón',
      KE: 'Kenia',
      KG: 'Kirguistán',
      KH: 'Camboya',
      KI: 'Kiribati',
      KM: 'Comoras',
      KN: 'San Cristóbal y Nieves',
      KP: 'Corea del Norte',
      KR: 'Corea del Sur',
      KW: 'Kuwait',
      KY: 'Islas Caimán',
      KZ: 'Kazajistán',
      LA: 'Laos',
      LB: 'Líbano',
      LC: 'Santa Lucía',
      LI: 'Liechtenstein',
      LK: 'Sri Lanka',
      LR: 'Liberia',
      LS: 'Lesoto',
      LT: 'Lituania',
      LU: 'Luxemburgo',
      LV: 'Letonia',
      LY: 'Libia',
      MA: 'Marruecos',
      MC: 'Mónaco',
      MD: 'Moldavia',
      ME: 'Montenegro',
      MF: 'San Martín',
      MG: 'Madagascar',
      MH: 'Islas Marshall',
      MK: 'Macedonia del Norte',
      ML: 'Mali',
      MM: 'Birmania',
      MN: 'Mongolia',
      MO: 'Macao',
      MP: 'Islas Marianas del Norte',
      MQ: 'Martinica',
      MR: 'Mauritania',
      MS: 'Montserrat',
      MT: 'Malta',
      MU: 'Mauricio',
      MV: 'Maldivas',
      MW: 'Malaui',
      MX: 'México',
      MY: 'Malasia',
      MZ: 'Mozambique',
      NA: 'Namibia',
      NC: 'Nueva Caledonia',
      NE: 'Níger',
      NF: 'Isla Norfolk',
      NG: 'Nigeria',
      NI: 'Nicaragua',
      NL: 'Países Bajos',
      NO: 'Noruega',
      NP: 'Nepal',
      NR: 'Nauru',
      NU: 'Niue',
      NZ: 'Nueva Zelanda',
      OM: 'Omán',
      PA: 'Panamá',
      PE: 'Perú',
      PF: 'Polinesia Francesa',
      PG: 'Papúa Nueva Guinea',
      PH: 'Filipinas',
      PK: 'Pakistán',
      PL: 'Polonia',
      PM: 'San Pedro y Miquelón',
      PN: 'Islas Pitcairn',
      PR: 'Puerto Rico',
      PS: 'Palestina',
      PT: 'Portugal',
      PW: 'Palaos',
      PY: 'Paraguay',
      QA: 'Catar',
      RE: 'Reunión',
      RO: 'Rumania',
      RS: 'Serbia',
      RU: 'Rusia',
      RW: 'Ruanda',
      SA: 'Arabia Saudita',
      SB: 'Islas Salomón',
      SC: 'Seychelles',
      SD: 'Sudán',
      SE: 'Suecia',
      SG: 'Singapur',
      SH: 'Santa Elena',
      SI: 'Eslovenia',
      SJ: 'Svalbard y Jan Mayen',
      SK: 'Eslovaquia',
      SL: 'Sierra Leona',
      SM: 'San Marino',
      SN: 'Senegal',
      SO: 'Somalia',
      SR: 'Surinam',
      SS: 'Sudán del Sur',
      ST: 'Santo Tomé y Príncipe',
      SV: 'El Salvador',
      SX: 'Sint Maarten',
      SY: 'Siria',
      SZ: 'Suazilandia',
      TC: 'Islas Turcas y Caicos',
      TD: 'Chad',
      TF: 'Territorios Australes Franceses',
      TG: 'Togo',
      TH: 'Tailandia',
      TJ: 'Tayikistán',
      TK: 'Tokelau',
      TL: 'Timor Oriental',
      TM: 'Turkmenistán',
      TN: 'Túnez',
      TO: 'Tonga',
      TR: 'Turquía',
      TT: 'Trinidad y Tobago',
      TV: 'Tuvalu',
      TW: 'Taiwán',
      TZ: 'Tanzania',
      UA: 'Ucrania',
      UG: 'Uganda',
      UM: 'Islas menores alejadas de EE. UU.',
      US: 'Estados Unidos',
      UY: 'Uruguay',
      UZ: 'Uzbekistán',
      VA: 'Ciudad del Vaticano',
      VC: 'San Vicente y las Granadinas',
      VE: 'Venezuela',
      VG: 'Islas Vírgenes Británicas',
      VI: 'Islas Vírgenes de EE. UU.',
      VN: 'Vietnam',
      VU: 'Vanuatu',
      WF: 'Wallis y Futuna',
      WS: 'Samoa',
      YE: 'Yemen',
      YT: 'Mayotte',
      ZA: 'Sudáfrica',
      ZM: 'Zambia',
      ZW: 'Zimbabue',
      jurisdictionTitles: {
        bahamas: 'BAHAMAS'
      }
    },

    // Etiquetas
    labels: {
      lblEmail: 'Correo electrónico *',
      lblOccupation: 'Ocupación *',
      lblNationalID: 'Identidad Nacional *',
      lblNationalIDPlain: 'Identidad Nacional',
      lblDriverLicence: 'Licencia de conducir',
      lblDocumentType: 'Tipo de documento *',
      lblDocumentFront: 'Frente del documento *',
      lblDocumentBack: 'Reverso del documento *',
      lblAddressProofOwner: 'El comprobante de domicilio está a nombre de *',
      lblAddressProofOwnerSelf: 'Accionista / director',
      lblAddressProofOwnerOther: 'Otra persona',
      lblKinshipDegree: 'Grado de parentesco *',
      lblPassportMockupAlt: 'Ejemplo de pasaporte',
      lblIdentityMockupAlt: 'Ejemplo de identidad nacional',
      lblDocumentExample: 'Ejemplo de documento',
      lblSeeExample: 'Ver ejemplo',
      lblScanPassport: 'Escanear pasaporte',
      lblScanPassportHint: 'Apunte la cámara a la página de datos del pasaporte. La lectura ocurre sola.',
      lblScanPassportPermission: 'Permita el acceso a la cámara para escanear el pasaporte.',
      lblScanPassportDenied:
        'Se denegó el permiso de la cámara. Actívelo en la configuración del navegador, envíe una foto del documento o complete los campos manualmente.',
      lblScanPassportUnavailable: 'Cámara no disponible. Envíe una foto del documento o complete los campos manualmente.',
      lblScanPassportPreparing: 'Preparando el lector...',
      lblScanPassportSearching: 'Buscando los datos del pasaporte...',
      lblScanPassportTip: 'Acerque el pasaporte hasta que las dos líneas inferiores llenen el recuadro y evite reflejos.',
      lblScanPassportFailed: 'No se pudo iniciar el lector. Inténtelo de nuevo.',
      lblScanPassportRetry: 'Intentar de nuevo',
      lblScanPassportUpload: '¿No funciona? Envíe una foto del documento',
      lblScanPassportCapture: 'Leer esta imagen',
      lblScanPassportCapturing: 'Leyendo la imagen...',
      lblScanPassportReadingPhoto: 'Leyendo la foto...',
      lblScanPassportPhotoFailed:
        'No se pudo leer esa foto. Envíe la página de datos nítida, sin reflejos, con las dos líneas inferiores visibles.',
      lblScanPassportFound: 'Encontramos estos datos',
      lblScanPassportReviewHint:
        'Revise si está todo correcto antes de usarlos. La lectura puede confundir letras parecidas, como S y B o G y O.',
      lblScanPassportUseData: 'Usar estos datos',
      lblScanPassportScanAgain: 'Escanear de nuevo',
      lblPassportExampleTitle: 'Ejemplo de pasaporte',
      lblIdentityExampleTitle: 'Ejemplo de identidad nacional',
      lblIdentityOpenHint: 'Envíe el documento abierto, con frente y reverso visibles',
      lblIdentityFront: 'Frente',
      lblIdentityBack: 'Reverso',
      lblIdentityFrontAlt: 'Frente de la identidad',
      lblIdentityBackAlt: 'Reverso de la identidad',
      lblSharesUnitsRangeHelper: 'Rango permitido: 1 – 50.000',
      lblLastName: 'Apellido *',
      lblFirstName: 'Nombre *',
      lblNotification: 'Notificación',
      lblPassword: 'Contraseña',
      lblConfirmPassword: 'Confirmar Contraseña',
      lblPronoun: 'Pronombre',
      lblLegalPersonality: 'Personalidad legal',
      lblCompanyProfile: 'Perfil de la Empresa',
      lblJurisdictions: 'Jurisdicción',
      lblMainGoals: 'Mis principales objetivos son',
      lblTypeOfCompany: 'Tipo de empresa',
      lblNumDirectors: 'Número de directores',
      lblNumMinors: 'Número de menores',
      lblNumShareholders: 'Número de accionistas',
      lblEntityDirectors: 'Directores de la entidad',
      lblEntityDirectorsNames: 'Nombres de los directores de la entidad',
      lblNumShareholdersUnderage: 'Número de accionistas menores de edad',
      lblEntityPronoun: 'Pronombre de la entidad',
      lblEntityShareholders: 'Accionistas de la entidad',
      lblEntityShareholdersNames: 'Nombres de los accionistas de la entidad',
      lblEntityShareholdersUnderage: 'Accionistas menores de edad en la entidad',
      lblObjective: 'Objetivo',
      lblPersonality: 'Personalidad',
      lblRegistrationCountry: 'País de registro',
      lblWhyDidYouChoose: '¿Cuáles son las ventajas de esta jurisdicción?',
      lblWhyShareholders: `
        <p>Considere en este recuento el número total de accionistas, independientemente de si son directores o no, o si tienen una pequeña participación en el negocio.</p>

        <p>Nos gustaría destacar nuestras políticas de <strong>Conozca a su Cliente (KYC)</strong>, que son rigurosas y cumplen con las leyes y regulaciones internacionales. Nuestro compromiso es mantener un entorno de negocios seguro y transparente para todos nuestros clientes.</p>

        <h5>Quienes pueden enfrentar restricciones:</h5>

        <p><strong>Personas Políticamente Expuestas (PPE)</strong>: Dada la naturaleza sensible y el riesgo potencial de corrupción asociado con las PPE, es difícil para nuestra empresa aprobar a tales individuos sin verificaciones rigurosas y extensas.</p>

        <p><strong>Funcionarios Públicos</strong>: Aquellos que desempeñan funciones públicas, especialmente en posiciones que influyen en decisiones financieras, están sujetos a un escrutinio KYC más riguroso y es posible que no sean aprobados.</p>

        <p><strong>Personas Condenadas por Delitos</strong>: Especialmente aquellas condenadas por tráfico, delitos financieros u otros delitos graves, es poco probable que sean aprobadas a través de nuestro proceso de KYC.</p>

        <p><strong>Sin Comprobación de Ingresos</strong>: Los clientes que no pueden proporcionar una prueba adecuada de ingresos o de la fuente de fondos también pueden enfrentar dificultades para superar nuestras verificaciones de KYC.</p>

        <h5>Proceso de Verificación:</h5>

        <p>Nuestro proceso de verificación incluye, entre otros, la verificación de documentos, verificación de antecedentes y cumplimiento de listas de sanciones internacionales. Hacemos esto para proteger a nuestros clientes y mantener la integridad de nuestro entorno empresarial.</p>

        <p>Si usted entra en una de las categorías mencionadas anteriormente, tenga en cuenta que el proceso de verificación puede llevar tiempo y no se garantiza la aprobación.</p>
      `,

      lblWhyDirectors: `
        <h5>Funciones del Director</h5>
        <p>Los directores de una entidad offshore son responsables de supervisar las operaciones generales de la empresa y garantizar que sus actividades cumplan con las leyes y regulaciones aplicables. Sus funciones incluyen, entre otras, establecer objetivos estratégicos, aprobar políticas internas y trabajar con ejecutivos y empleados para asegurar su correcta implementación. Los directores también deben proteger los activos de la empresa y actuar en el mejor interés de la entidad.</p>

        <h5>Políticas de KYC y Cumplimiento:</h5>
        <p>Deseamos destacar que nuestros procedimientos de Know Your Customer (KYC) son rigurosos y están totalmente alineados con los estándares internacionales de cumplimiento. Nuestra prioridad es mantener un entorno empresarial seguro y transparente para todos nuestros clientes.</p>

        <h5>Quiénes Pueden Enfrentar Restricciones:</h5>
        <p>Ciertas categorías de individuos pueden estar sujetas a una debida diligencia reforzada o pueden no ser aprobadas durante el proceso de incorporación:</p>
        <ul>
          <li><strong>Personas Políticamente Expuestas (PEPs):</strong> Debido al mayor riesgo asociado con actos de corrupción o abuso de cargos públicos, los PEPs requieren comprobaciones de antecedentes exhaustivas. Su aprobación puede ser difícil y no está garantizada.</li>
          <li><strong>Funcionarios Públicos:</strong> Las personas que desempeñan funciones públicas—especialmente aquellas con influencia en decisiones financieras—están sujetas a revisiones de KYC más estrictas y pueden ser rechazadas según la evaluación de riesgo.</li>
          <li><strong>Personas con Condenas Penales:</strong> Aquellos condenados por tráfico, delitos financieros, fraude u otros delitos graves probablemente no cumplirán con nuestros requisitos de cumplimiento.</li>
          <li><strong>Sin Comprobante de Ingresos o de Origen de Fondos:</strong> Los solicitantes que no puedan proporcionar pruebas satisfactorias de ingresos o documentación que demuestre el origen legítimo de los fondos pueden enfrentar retrasos o la no aprobación.</li>
        </ul>

        <h5>Proceso de Verificación:</h5>
        <p>Nuestro proceso de verificación incluye, pero no se limita a:</p>
        <ul style="list-style: disc; padding-left: 1.5rem; margin: 0.75rem 0 1rem;">
          <li style="margin-bottom: 0.35rem;">verificación de identidad y documentación</li>
          <li style="margin-bottom: 0.35rem;">comprobaciones de antecedentes e integridad</li>
          <li style="margin-bottom: 0.35rem;">revisión de listas internacionales de sanciones</li>
          <li>evaluación del origen del patrimonio y del origen de los fondos</li>
        </ul>
        <p>Estas medidas garantizan la protección de todos los clientes y preservan la integridad de nuestro ecosistema corporativo.</p>

        <h5>Aviso Importante:</h5>
        <p>Si usted se encuentra dentro de alguna de las categorías mencionadas, tenga en cuenta que el proceso de verificación puede tardar más de lo habitual y su aprobación no está garantizada.</p>
      `,

      lblWhyDidYouChooseDescription: `
        <h5>1. Beneficios fiscales</h5>
        <p><strong>Sin impuestos corporativos:</strong> Las entidades registradas en Bahamas pero que operan fuera del país no están sujetas a impuestos corporativos, sobre ingresos o sobre ganancias de capital.</p>
        <p><strong>Sin retención en la fuente:</strong> No se aplican retenciones sobre dividendos, intereses ni regalías pagadas al exterior.</p>
        <p><strong>Régimen territorial:</strong> Solo se gravan actividades desarrolladas dentro de Bahamas, lo que favorece a estructuras con operaciones internacionales.</p>
        <h5>2. Confidencialidad</h5>
        <p><strong>Protección razonable de la información:</strong> Aunque Bahamas cumple estándares internacionales de transparencia, la información sobre directores y accionistas no es de acceso público, lo que ofrece un nivel adecuado de privacidad corporativa.</p>
        <h5>3. Entorno regulatorio favorable</h5>
        <p><strong>Legislación moderna y flexible:</strong> El marco legal corporativo es estable, actualizado y amigable para inversionistas extranjeros.</p>
        <p><strong>Estabilidad política y jurídica:</strong> Bahamas es reconocida por su institucionalidad sólida, lo que genera mayor seguridad para los propietarios y beneficiarios.</p>
        <h5>4. Facilidad para hacer negocios</h5>
        <p><strong>Bajos requerimientos de reporte:</strong> Las obligaciones de mantenimiento y presentación de información son más simples que en muchas otras jurisdicciones.</p>
        <p><strong>Incorporación rápida:</strong> El proceso puede completarse en pocos días, con trámites claros y eficientes.</p>
        <h5>5. Infraestructura profesional</h5>
        <p><strong>Especialistas experimentados:</strong> El país cuenta con una red consolidada de abogados, contadores y agentes corporativos con amplia experiencia en estructuras offshore.</p>
        <h5>6. Protección de activos</h5>
        <p><strong>Herramientas sólidas:</strong> Las estructuras corporativas y los fideicomisos de Bahamas permiten una planificación eficaz para protección patrimonial, dificultando la incautación de activos por entidades extranjeras sin el debido processo.</p>
        <p><strong>Sin controles cambiarios:</strong> No existen restricciones significativas para la movimentación internacional de fondos por parte de entidades offshore.</p>
      `,

      lblWhyDidYouChooseDescriptionDelaware: `
        <h5>Incorpore su Empresa en Delaware: El Mejor Destino para su LLC</h5>

        <p><strong>¿Por qué Delaware es la elección ideal para su LLC?</strong></p>

        <p>Delaware es la jurisdicción preferida por emprendedores, inversionistas y empresas globales. Su combinación única de beneficios fiscales, protección legal y facilidad operativa lo convierte en uno de los estados más atractivos para formar una empresa en los Estados Unidos.</p>

        <h5>Beneficios Fiscales Atractivos:</h5>
        <ul>
          <li><strong>Sin Impuestos Estatales sobre Ganancias:</strong> Delaware no cobra impuestos sobre la renta o ganancias de las LLC que operan fuera del estado.</li>
          <li><strong>Sin Impuestos de Retención:</strong> No impone impuestos de retención sobre dividendos, intereses o regalías pagados fuera del estado.</li>
        </ul>

        <h5>Confidencialidad y Privacidad:</h5>
        <ul>
          <li><strong>Protección de la Privacidad de los Propietarios:</strong> No es necesario divulgar públicamente los nombres de los miembros o gerentes de la empresa.</li>
        </ul>

        <h5>Entorno Regulatorio Amigable con los Negocios:</h5>
        <ul>
          <li><strong>Leyes Flexibles:</strong> Diseñadas para fomentar el crecimiento y la innovación.</li>
          <li><strong>Estabilidad Legal y Política:</strong> El Tribunal de Cancillería garantiza resoluciones eficientes y transparentes.</li>
        </ul>

        <h5>Facilidad de Operación:</h5>
        <ul>
          <li><strong>Formación Rápida y Simple:</strong> El registro puede completarse en solo un día.</li>
          <li><strong>Informes Mínimos y Costos Accesibles:</strong> Menos burocracia y tasas anuales accesibles.</li>
        </ul>

        <h5>Protección de Activos y Seguridad Jurídica:</h5>
        <ul>
          <li><strong>Fuerte Protección para los Miembros:</strong> Separación entre bienes personales y activos de la LLC.</li>
          <li><strong>Sin Restricciones para el Movimiento de Fondos:</strong> Capital puede transferirse libremente.</li>
        </ul>

        <h5>Infraestructura Profesional de Clase Mundial:</h5>
        <ul>
          <li><strong>Especialización en Negocios:</strong> Delaware cuenta con expertos en contabilidad, derecho y consultoría financiera.</li>
        </ul>

        <h5>Conclusión:</h5>

        <p>Delaware ofrece todo lo que necesita para crear y hacer crecer un negocio exitoso: beneficios fiscales excepcionales, una sólida protección legal, un entorno favorable y una infraestructura especializada.</p>

        <p><strong>Si está buscando una jurisdicción que combine flexibilidad, seguridad y eficiencia, Delaware es la opción correcta para su LLC.</strong></p>

        <p>Incorpore su empresa en Delaware hoy mismo y aproveche todos los beneficios que el estado tiene para ofrecer a las empresas globales.</p>
      `,

      lblInstructionForBecause:
        'Esta información se proporciona como una guía para los clientes, ya que asistimos a más de 1.000 usuarios en la creación de empresas offshore en esta jurisdicción.',

      lblIncorpIn: 'Incorporarse en',
      lblIncorp: 'Incorporar en',
      lblSelectAddons: 'Selecciona tus complementos',
      lblBilling: 'Facturaciones y Pagos',
      lblAnnualRenewal: 'Renovación Anual',
      lblAnnualFee: 'Tasa Anual',
      lblWhatIsAnnualFee: '¿Qué es la Tasa Anual?',
      lblAnnualFeeIncludes: 'La Tasa Anual Incluye:',
      lblAnnualFeeInclude1: 'Mantenimiento del registro de la empresa',
      lblAnnualFeeInclude2: 'Organización y Gestión de Documentos de la Empresa',
      lblAnnualFeeInclude3: 'Cumplimiento regulatorio',
      lblAnnualFeeInclude4: 'Soporte administrativo',
      lblWhyAnnualFeeImportant: '¿Por qué es Importante la Tasa Anual?',
      lblCompliance: 'Cumplimiento',
      lblLegalStatus: 'Estatus Legal',
      lblBusinessContinuity: 'Continuidad del Negocio',
      lblReadyToProceed: 'Listo para Proceder',
      lblPrefereces: 'Preferencias',
      lblPreferences: 'Preferencias',
      lblEnvironmentSetup: 'Configuración del entorno',
      lblPaymentStatus: 'Estado del pago',
      lblEnquiry: 'Support',
      lblDetails: 'Detalles',
      lblViewDetails: 'Ver Detalles',
      lblAddons: 'Complementos',
      lblAddon: 'Complemento',
      lblNoAddons: 'Sin Complementos',
      lblRepeatPassWord: 'Repita su contraseña',
      lblCardholderName: 'Nombre del Titular de la Tarjeta *',
      lblExpiration: 'Vencimiento',
      lblCardNumber: 'Número de Tarjeta',
      lblDebitCard: 'Tarjeta de Débito',
      lblPaymentDetails: 'Detalles de pago',
      lblPayYourRequest: 'Pague su solicitud',
      lblShareholder: 'Accionista',
      lblMembers: 'Miembros',
      lblUploadCertificates: 'Subir Documentos de la Empresa',
      // Upload individual de documentos
      selectFileFirst: 'Por favor, seleccione un archivo primero',
      selectDateFirst: 'Por favor, seleccione una fecha de emisión primero',
      uploaded: 'Enviado',
      download: 'Descargar',
      documentUploadedOn: 'Enviado el',
      fileName: 'Archivo',
      fileSelected: 'Archivo seleccionado',
      moreFiles: 'más archivos',
      uploading: 'Enviando...',
      uploadThisDocument: 'Enviar Este Documento',
      documentAlreadyUploaded: 'Documento ya enviado',
      uploadStatus: 'Estado del Envío',
      documentsUploaded: 'documentos enviados',
      requiredDocumentsUploaded: 'documentos requeridos enviados',
      allRequiredDocumentsUploaded: 'Todos los documentos requeridos han sido enviados',
      readyToApprove: 'Listo para aprobar la empresa',
      sealCopyNotRequired: 'Este documento no es requerido para aprobación',
      uploadRemaining: 'Enviar Documentos Restantes',
      noFilesSelected: 'No se seleccionaron archivos para los documentos restantes',
      allDocumentsUploaded: 'Todos los documentos han sido enviados',
      documentUploadedSuccessfully: 'Documento enviado exitosamente',
      // Status de documentos
      approved: 'Aprobado',
      pending: 'Pendiente',
      rejected: 'Rechazado',
      notUploaded: 'No Enviado',
      // Upload de documentos específicos
      uploadDocument: 'Enviar Documento',
      uploadAddress: 'Enviar Dirección',
      uploadDocumentDescription: 'Enviar un documento para este accionista',
      uploadPassportDescription: 'Enviar un pasaporte para este accionista',
      uploadAddressDescription: 'Enviar un documento de dirección para este accionista',
      registrationCompleted: 'Registro Completado',
      documentSuccessfullyUploaded: 'Documento enviado exitosamente',
      uploadNewVersion: 'Enviar Nueva Versión',
      clickToUploadNewVersion: 'Haga clic para enviar una nueva versión',
      uploadedDocuments: 'Documentos Enviados',
      sending: 'Enviando...',
      sendRegistrationData: 'Enviar Datos de Registro',
      registrationStatus: 'Estado del Registro',
      completed: 'Completado',
      lblInputFirstMessage: 'Ingrese el primer mensaje',
      lblMyFirstMessageIs: 'Mi primer mensaje es...',
      lblSendMessage: 'Enviar un mensaje',
      lblReasonForMoreInfo: 'Motivo para más información',
      lblCompanyInfo: 'Información de la Empresa',
      lblMailroom: 'Sala de Correo',
      lblContactUs: 'Contáctenos',
      lblRegistrationNo: 'Número de Registro',
      lblNoRegistrationNumber: 'Sin Número de Registro',
      lblCompanyStatus: 'Estado de la Empresa',
      lblIncorporationDate: 'Fecha de Constitución',
      lblViewMore: 'Ver más',
      lblCompanyDocuments: 'Documentos de la Empresa',
      lblNoDocuments: 'No tienes documentos',
      lblNoNotifications: 'No tienes notificaciones',
      lblNoNameDocument: 'Documento sin título',
      lblPdfDocument: 'Documento PDF',
      lblSubscriberType: 'Tipo de Firmante',
      lblSubscriberName: 'Nombre del Firmante',
      lblDocumentationStatus: 'Estado de la documentación',
      lblDocument: 'Documento',
      lblAnalyzeDocuments: 'Ver Documentos',
      lblDirectorsAndShareholders: 'Directores y Accionistas',
      lblCompanySecretary: 'Secretario de la Empresa',
      lblAccounting: 'Contabilidad',
      lblRequests: 'Solicitudes',
      lblOnGoing: 'En curso',
      lblCompanyDetails: 'Detalles de la Empresa',
      lblCompanyName: 'Tu compañía',
      lblFinancialYear: 'Año Fiscal',
      lblDirectors: 'Directores',
      lblTransferCompany: 'Empresa de transferencia',
      lblAddress1: 'Dirección 1 *',
      lblAddress2: 'Dirección 2',
      lblPostalCode: 'Código Postal *',
      lblCity: 'Ciudad *',
      lblState: 'Estado *',
      lblNeighborhood: 'Barrio *',
      lblCountry: 'País',
      lblEconomicSubstance: 'Sustancia Económica',
      lblMainActivities: 'Main activities',
      lblPrincipalActivity: 'Actividad primarias',
      lblSecondaryActivity: 'Actividad Secundaria',
      lblShareName: 'Nombre de las Acciones',
      lblTotalPaidUpCapital: 'Capital Social Pagado Total',
      lblTotalIssuedShareCapital: 'Capital Social Emitido Total',
      lblTotalNumberOfShares: 'Número Total de Acciones',
      lblSelectChat: 'Seleccionar un Chat para ver nuevos mensajes',
      lblSearchPeople: 'Buscar usuario',
      lblTypeHere: 'Escribe aquí...',
      lblSearchCompany: 'Buscar empresa...',
      lblSearchEmail: 'Buscar correo...',
      lblGeneralDocuments: 'Documentos Generales',
      lblDocumentName: 'Nombre del Documento',
      lblMessageStatus: 'Mensaje',
      lblView: 'Vista',
      lblType: 'Tipo',
      lblRole: 'Cargo',
      lblDatePosted: 'Fecha de Publicación',
      lblStatus: 'Estado',
      lblActions: 'Acciones',
      lblID: 'ID',
      lblTotalDocuments: 'Documentos Totales',
      lblInputInformationDirectors: 'Por favor, proporcione la información del director',
      lblDirector: 'Director',
      lblPendingUploadFile: 'Pendiente de subir archivo',
      lblCompleted: 'Completado',
      lblDirectorShareholder: 'Director/Accionista',
      lblNoDataAvailable: 'Datos no disponibles',
      lblNoDirectorsOrShareholders: 'Ningún director o accionista registrado aún.',
      lblPage: 'La página',
      lblNextPage: 'Siguiente',
      lblPevPage: 'Anterior',
      lblToNextPage: 'En',
      lblGender: 'Género *',
      lblGenderMale: 'Masculino',
      lblGenderFemale: 'Femenino',
      lblDateOfBirth: 'Fecha de Nacimiento (aaaa/mm/dd)*',
      lblPhone: 'Teléfono*',
      lblPhoneLess: 'Teléfono',
      lblNationality: 'País de nacimiento *',
      lblPassportNo: 'Número de Pasaporte*',
      lblExpiryDate: 'Fecha de Vencimiento del Pasaporte (aaaa/mm/dd)*',
      lblPassportIssuingCountry: 'País de Emisión del Pasaporte*',
      lblIssueDate: 'Fecha de Emisión del Pasaporte (aaaa/mm/dd)*',
      lblIssueDateLess: 'Fecha de Emisión',
      lblUploadDirectorsDocuments: 'Subir documento del director',
      lblUploadShareholdersDocuments: 'Cargar documento del accionista',
      lblUploadMembersDocuments: 'Cargar Documento de los miembros',
      lblPassport: 'Pasaporte',
      // Passport Upload Modal
      passportExpired: 'Pasaporte Vencido',
      expiresIn: 'Vence en',
      days: 'días',
      valid: 'Válido',
      email: 'Email',
      passportNo: 'Número de Pasaporte',
      passportExpiry: 'Vencimiento del Pasaporte',
      datePosted: 'Fecha de Publicación',
      uploadNewPassport: 'Cargar Nuevo Pasaporte',
      renewPassport: 'Renovar Pasaporte',
      unnamed: 'Sin nombre',
      noEmail: 'Sin email',
      noPassport: 'Sin pasaporte',
      unknown: 'Desconocido',
      noDirectorsOrShareholders: 'Sin Directores o Accionistas',
      noDirectorsOrShareholdersAdded: 'No se han agregado directores o accionistas aún.',
      // Passport Upload Modal
      passportUploadTitle: 'Cargar Nuevo Pasaporte',
      passportUploadDescription: 'Cargue un nuevo documento de pasaporte para {{name}}.',
      uploadPassportDocument: 'Cargar Documento del Pasaporte',
      uploadPassportDocumentDescription: 'Cargar su documento de pasaporte',
      documentUpload: 'Carga de Documento',
      passportInformation: 'Información del Pasaporte',
      passportNumber: 'Número de Pasaporte',
      expiryDate: 'Fecha de Vencimiento',
      issueDate: 'Fecha de Emisión',
      passportIssuingCountry: 'País de Emisión del Pasaporte',
      selectCountry: 'Seleccionar un país',
      passportDocument: 'Documento del Pasaporte',
      uploadYourDocument: 'Cargue su documento',
      orSearchInComputer: 'o busque en su computadora',
      supportedFormats: 'Formatos admitidos: PDF o DOC | Tamaño máximo: 3MB',
      uploadPassport: 'Cargar Pasaporte',
      passportUpdatedSuccessfully: 'Pasaporte actualizado exitosamente',
      passportNumberRequired: 'El número de pasaporte es requerido',
      issuingCountryRequired: 'El país de emisión es requerido',
      issueDateRequired: 'La fecha de emisión es requerida',
      passportFileRequired: 'El archivo del pasaporte es requerido',
      lblLocalDocument: 'Identidad Nacional',
      lblProveAddress: 'Comprobante de Domicilio',
      lblPersonalDocuments: 'Documentos Personales',
      lblNoCompanyDocumentsDescription: 'Aún no se han enviado documentos de la empresa.',
      lblSigned: 'Firmado',
      lblUnsigned: 'Sin Firmar',
      lblNextStep: 'Siguiente Paso',
      lblPushYourDocument: 'Subir su Documento',
      lblClickToUpload: 'Hacer clic para subir',
      lblUpload: 'Subir',
      lblSuccessYourDocument: 'Documento enviado exitosamente',
      lblOrSearchInYourComputer: 'o buscar en su computadora',
      lblDocumentsSupported: 'Documentos admitidos: PDF o DOC | Tamaño máximo: 30 MB',
      lblDocumentsSupportedEnquiry: 'Documents admitidos: IMG or PDF | Tamaño máximo: 5MB',
      lblInputInformationShareholders: 'Por favor proporcione información del accionista',
      lblInputInformationMembers: 'Por favor proporcione información de los miembro',
      lblShareDetails: 'Detalles de las Acciones',
      lblShareIssuanceDate: 'Fecha de Emisión de Acciones (aaaa/mm/dd)*',
      lblClassOfShares: 'Clase de Acciones',
      lblSelectClassShare: 'Seleccione una clase de acciones',
      lblSeriesOfShares: 'Serie de Acciones*',
      lblPrivilegesRestrictions: 'Privilegios/Restricciones (si las hay)',
      lblConditions: 'Condiciones (si las hay)',
      lblRequestsBar: 'Peticiones',
      lblTypeDocuments: 'Tipo',
      lblWeveHelped: 'Hemos ayudado a más de 1000 clientes a crear empresas offshore',
      lblAdditionalSelect: 'Seleccione su Jurisdicción',
      lblBackToHomePage: 'Ir a la página de inicio',
      lblAdminModeSkipPayment: 'Modo admin: saltar pago',
      lblSelectYourCompany: 'Seleccione su empresa',
      lblSelect: 'Seleccione',
      lblSelectType: 'Seleccione el tipo',
      lblReset: 'Reiniciar',
      lblPrimaryColor: 'Colores principales',
      lblButtonColor: 'Colores de los botones',
      lblBorderColor: 'Colores de Bordes',
      lblSelectStatus: 'Seleccionar Estado',
      lblLoading: 'Cargando',
      lblNoRecords: 'No se encontraron registros',
      lblExactDateFilter: 'Buscar por fecha exacta',
      lblExactDate: 'Fecha exacta',
      activeFilters: 'Filtros Activos',
      resultsFound: 'resultados encontrados',
      lblDueDate: 'Fecha de Vencimiento',
      lblAmount: 'Monto',
      lblRenewalAddonsTitle: 'Agregue extras a su renovación',
      lblRenewalAddonsDescription: 'Como está renovando, también puede agregar servicios o características adicionales a su empresa. Estos son opcionales y se pueden cambiar más tarde.',
      lblStartingFrom: 'A partir de',
      lblNoCompanyName: 'Sin nombre de empresa definido',
      lblCorporateDirector: 'Director Corporativo',
      lblIncluded: 'Incluido',
      
      // Director/Shareholder Dashboard
      lblMyProfile: 'Mi Perfil',
      lblViewAndEdit: 'Ver y editar su información',
      lblProfileComplete: 'Perfil Completo',
      lblViewProfile: 'Ver Perfil',
      lblMyDocuments: 'Mis Documentos',
      lblDocumentStatus: 'Consulte el estado de sus documentos',
      lblSubmitted: 'Documentos Enviados',
      lblComingSoon: 'Próximamente',
      lblYourCurrentStatus: 'Su estado actual',
      lblActive: 'Activo',
      lblViewYourDocuments: 'Ver Documentos',
      lblNoDocumentsDescription: 'Aún no ha enviado ningún documento.',
      lblDocuments: 'documentos',
      lblUntitledDocument: 'Documento Sin Título',
      lblUploadedOn: 'Subido el',
      lblDownload: 'Descargar',
      lblApproved: 'Aprobado',
      lblRejected: 'Rechazado',
      lblPending: 'Pendiente',
      lblPassports: 'Pasaportes',
      lblIssuingCountry: 'País Emisor',
      lblAddressDocuments: 'Documentos de Dirección',
      lblAddressProof: 'Comprobante de Dirección',
      lblDocumentsInfo: 'Los documentos son revisados por nuestro equipo. Se le notificará una vez completada la revisión.',
      lblNoCompanyLinked: 'Sin Empresa Vinculada',
      lblNoCompanyLinkedDescription: 'Actualmente no está vinculado a ninguna empresa. Póngase en contacto con el soporte si cree que esto es un error.',
      lblAboutDirectorDashboard: 'Acerca del Panel de Director/Accionista',
      lblDirectorDashboard: 'Panel de Director/Accionista',
      lblDirectorDashboardDescription: 'Este panel le permite ver y administrar su información personal como director o accionista. Puede actualizar sus datos, ver sus documentos y hacer seguimiento de su estado.',
      lblRecentUpdates: 'Actualizaciones recientes',
      lblAllCaughtUp: '¡Estás al día!',
      lblViewAll: 'Ver Todo',
      
      // Profile Page
      lblManageYourPersonalInfo: 'Administre su información personal',
      lblEdit: 'Editar',
      lblSave: 'Guardar',
      lblSaving: 'Guardando...',
      lblPersonalInformation: 'Información Personal',
      lblBirthDate: 'Fecha de Nacimiento',
      lblAddress: 'Dirección',
      lblStreet: 'Calle',
      lblZipCode: 'Código Postal',
      lblOfficialDocuments: 'Documentos Oficiales',
      lblPassportNumber: 'Número de Pasaporte',
      lblTaxId: 'Número de Identificación Fiscal',
      lblClickEditToUpdate: 'Haga clic en el botón "Editar" para actualizar su información',
      annualFeeIntroText: 'En los próximos pasos, podrá revisar los datos de su empresa offshore y, si lo desea, seleccionar addons que aporten valor a su operación.\nAl final, continuará con el pago de la tarifa anual correspondiente a la jurisdicción de su empresa.\n¿Empezamos?',
      cancel: 'Cancelar',
      clickToChangeFile: 'Haga clic para cambiar el archivo'
    },

    // Campos
    fields: {
      fldConfirmPwdPlaceholder: 'Ejemplo: 12345#!2',
      fldEmailPlaceholder: 'Ejemplo: Ariel@offshore2go.com',
      fldLastNamePlaceholder: 'Ejemplo: Souza',
      fldFirstNamePlaceholder: 'Ejemplo: Ariel',
      fldPronounPlaceholder: 'Selecciona tu pronombre',
      fldSelectYourOption: 'Selecciona tu opción',
      fldPwdPlaceholder: 'Ejemplo: 12345#!2',
      fldFieldNumber: 'El campo debe ser un número',
      fldOnboarding: 'Integración'
    },

    // Títulos
    titles: {
      ttlResetPwd: 'Restablecer tu contraseña',
      ttlCreateAccount: 'Crear tu cuenta',
      ttlDefineObjectives: 'Selecciona tus principales objetivos',
      ttlChooseObjectives: '¿Cuál es tu objetivo principal?',
      ttlCreateNewOffshore: 'Quiero crear una nueva Offshore',
      ttlTransferExistingOffshore: 'Quiero transferir una Offshore existente',
      ttlSummary: 'Resumen de tu compra',
      ttlOffshorePackage: 'Su paquete Offshore2Go',
      ttlDirectorsCount: '¿Cuántos directores tendrá su empresa offshore?',
      ttlJurisdiction: 'Definir tu jurisdicción',
      ttlAddons: 'Por favor selecciona los complementos',
      ttlShareholderCount: '¿Cuántos accionistas tendrá su offshore?',
      ttlShareholderUnderagesCount: '¿Cuántos de estos accionistas tienen menos de 18 años?',
      ttlMembersCount: '¿Cuántos miembros tendrá su offshore?',
      ttlMembersUnderagesCount: '¿Cuántos miembros?',
      ttlMinorsCount: '¿Cuántos son menores de edad?',
      ttlConfirmation: 'Tu confirmación',
      ttlNotFound: 'Página no encontrada',
      ttlInstructionCardTitle: 'Instrucción para ti',
      ttlFinishRegister: 'Termina tu registro',
      ttlButtonInformation:
        'Debe firmar el acuerdo de usuario. Si ya has firmado el documento, espera unos instantes y actualice la página nuevamente.',
      ttlSigned: 'Firmado',
      ttlAlertContract:
        'Antes de continuar con su registro, necesitamos que firme el acuerdo de usuario con Offshore2go. Haga clic en el botón a continuación para ser redirigido a nuestro socio Forsign y firmar el contrato digitalmente. Si ya se ha suscrito, espere o actualice la página.',
      ttlSignTheContract: 'Descargar documentos',
      ttlDownload: 'Descargar',
      ttlDownloadDocument: 'Descargar documento',
      ttlVerifySignatures: 'Verificar firmas',
      ttlButtonSignTheContract: 'Debes firmar el contrato de usuario antes de finalizar tu registro.',
      ttlButtonSignTheContractNew: 'Firmar contrato',
      ttlButtonDownloadCertificated: 'Descarga tu certificado',
      ttlttlButtonDownloadCertificatedHover: 'Podrás descargar tu certificado una vez que tu empresa sea aprobada.',
      ttlButtonDownloadCertificatedIncorporation: 'Descargar Certificado de incorporación',
      ttlHello: 'Hola',
      ttlWelcome: 'Bienvenido',
      ttlSelectCompany: 'Seleccionar empresa',
      ttlHome: 'Inicio',
      ttlSubTituloInitial: 'INITIAL',
      ttlCompany: 'COMPAÑÍA',
      ttlConfig: 'AJUSTES',
      ttlEditPassWord: 'Edita tu contraseña',
      ttlEnquiryPage: '¿Cómo podemos ayudar?',
      ttlEnquirySelect: 'Asunto',
      ttlEnquiryMessage: 'Mensaje',
      ttlEnquiryAttachment: 'Adjunto',
      ttlThereNoRecords: 'Aún no hay registros.',
      ttlCustomizeMyPlatform: 'Personaliza mi plataforma',
      ttlBasicConfig: 'Configuración básica',
      ttlTooltipFormatImg: 'Atención: El logo de Offshore2go debe tener unas dimensiones de 798x155 píxeles para una mejor visualización. Formatos permitidos: PNG, JPG, JPEG y SVG.',
      ttlCLickOrDropDocuments: 'Haga clic o arrastre los archivos para cargarlos',
      ttlAnnualFeeIntro: '¡Bienvenido al proceso de renovación anual de su empresa!',
      annualFeeIntroText: 'En los próximos pasos, podrá revisar los datos de su empresa offshore y, si lo desea, seleccionar addons que aporten valor a su operación.\nAl final, continuará con el pago de la tarifa anual correspondiente a la jurisdicción de su empresa.\n¿Empezamos?',
      lblRenewalAddonsTitle: 'Agregue servicios extra a su renovación',
      lblRenewalAddonsDescription: 'Como está renovando, también puede agregar servicios o funcionalidades extra a su empresa. Estos son opcionales y pueden cambiarse más adelante.',
      lblNoCompanyName: 'Sin nombre de empresa definido'
    },

    descriptions: {
      PageAddonsDescription: 'No te preocupes, puedes cambiar tus preferencias en cualquier momento',
      Directors: 'Directores',
      CorporateDirector: 'Director corporativo',
      Shareholder: 'Accionista',
      OperationalCompany: 'Empresa Operativa',
      Startup: 'Startup',
      CommingSoon: 'Proximamente',
      ServicesDays: 'Días',
      Members: 'Miembros',
      renewalAddonsDescription: 'Ya que está renovando, también puede agregar servicios o funcionalidades extra a su empresa. Esto es opcional y puede cambiarse después.',
      annualFeeIntroText: 'En los próximos pasos, podrá revisar los datos de su empresa offshore y, si lo desea, seleccionar addons que aporten valor a su operación.\nAl final, continuará con el pago de la tarifa anual correspondiente a la jurisdicción de su empresa.\n¿Empezamos?',
    },

    config: {
      TabFees: 'Tarifas estándar',
      TabAddons: 'Complementos',
      TabDirectors: 'Directores y accionistas',
      TabJurisdictions: 'Jurisdicciones',
      TargetJuridiction: 'Jurisdicción meta',
      ColorPrimary: 'Primaria',
      ColorSecondary: 'Secundaria',
      ColorTertiary: 'Terciaria',
      Logo: 'Tipo de logo',
      UploadImageFile: 'Sube el archivo de imagen',
      Active: 'Activo',
      DirectorFee: 'Honorarios del director',
      ShareholdersFee: 'Cuota de accionista',
      CorporateDirectorFee: 'Honorarios del Director Corporativo',
      tooltipDirectorFee: 'Cuota cobrada por cada director individual designado en la empresa. Es el importe que paga el cliente por cada persona natural que actúa como director.',
      tooltipCorporateDirectorFee: 'Cuota por designar un director corporativo (una empresa que actúa como director). Suele usarse para estructuras o servicios de nominado.',
      tooltipShareholdersFee: 'Cuota cobrada por cada accionista. Es el importe que paga el cliente por cada persona o entidad que posee acciones en la empresa.'
    },
    environment: {
      manageAddons: 'Administrar complementos',
      styleSaved: 'Estilo guardado',
      removeImage: 'Quitar imagen',
      logoPreview: 'Vista previa del logo',
      selectColor: 'Seleccionar color',
      errorSavingFees: 'Error al guardar las tarifas.',
      noChangesToSave: 'No hay cambios para guardar.',
      errorSavingAddons: 'Error al guardar los complementos.',
      errorUpdatingJurisdiction: 'Error al actualizar la jurisdicción.',
      jurisdictionUpdatedSuccess: 'Jurisdicciones actualizadas.',
      addonsUpdatedSuccess: '¡Complementos actualizados con éxito!',
      stylesUpdatedSuccess: 'Estilos actualizados con éxito.',
      logoUploadedSuccess: '¡Logo subido con éxito!',
      feesUpdatedSuccess: 'Tarifas actualizadas con éxito.',
      userNotAuthenticated: 'Usuario no autenticado.',
      errorFetchingAddons: 'Error al cargar los complementos.',
      errorUpdatingFee: 'Error al actualizar la tarifa.',
      errorFetchingPlanInfo: 'Error al cargar la información del plan.',
      errorFetchingDirectorsShareholdersConfig: 'Error al cargar la configuración de directores/accionistas.'
    },

    // Mensajes
    messages: {
      msgCompanyAproved: 'Empresa completada y aprobada con éxito',
      msgFileSizeError: 'El archivo debe tener un máximo de 3MB',
      registrationDataSent: 'Datos de registro enviados con éxito',
      profileUpdatedSuccessfully: 'Perfil actualizado con éxito',
      errorUpdatingProfile: 'Error al actualizar el perfil. Por favor, inténtelo de nuevo.',
      errorLoadingDocuments: 'Error al cargar documentos. Por favor, inténtelo de nuevo.',
      errorLoadingCompanies: 'Error al cargar empresas. Por favor, inténtelo de nuevo.',
      passwordChangedSuccessfully: 'Contraseña cambiada con éxito',
      errorLoadingProfile: 'Error al cargar los datos del perfil. Por favor, inténtelo de nuevo.',
      msgDirectorsInstruction:
        'Nuestro equipo con 25 años de experiencia ha ayudado a más de 1,000 usuarios a establecer compañías en las Bahamas, Islas Caimán, Belice y Delaware, entre otras jurisdicciones.',
      msgShareholdersInstruction:
        'Nuestro equipo con 25 años de experiencia ha ayudado a más de 1,000 usuarios a establecer compañías en las Bahamas, Islas Caimán, Belice y Delaware, entre otras jurisdicciones.',
      msgConfirmInstruction:
        'Nuestro equipo con 25 años de experiencia ha ayudado a más de 1,000 usuarios a establecer compañías en las Bahamas, Islas Caimán, Belice y Delaware, entre otras jurisdicciones.',
      filterActive: 'Filtro activo',
      noAddonsAvailable: 'No hay complementos disponibles para este elemento.',
      annualRenewalIntro: 'Conozca la cuota anual y por qué es esencial mantener su empresa activa y en cumplimiento.',
      annualFeeDescription: 'La tasa anual es un pago obligatorio que debe realizarse anualmente para mantener tu empresa offshore activa y cumplir con las regulaciones locales.',
      annualFeeBenefits: 'Esta tasa garantiza que tu empresa mantenga su estatus legal y continúe operando sin interrupciones.',
      complianceDescription: 'Mantiene tu empresa cumpliendo con las leyes y regulaciones de la jurisdicción.',
      legalStatusDescription: 'Preserva el estatus legal de tu empresa y evita penalidades.',
      businessContinuityDescription: 'Garantiza que tus operaciones continúen sin interrupciones.',
      proceedDescription: 'Ahora puedes proceder a ver los detalles de tu tasa anual y seleccionar servicios adicionales.',
      showingResults: 'Mostrando',
      results: 'resultados',
      showingRange: 'Mostrando {{from}} - {{to}} de {{total}} resultados',
      pageInfo: 'Página {{current}} de {{last}}',
      documentUploadedSuccessfully: 'Documento enviado exitosamente'
    },

    // Validaciones
    validations: {
      valRequired: 'Rellene este campo',
      required: 'Este campo es obligatorio',
      valPwdRule: 'Debe contener 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial',
      valPwdAdvice: 'Debe contener 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial',
      valInvalidEmail: 'Correo electrónico no válido.',
      valPwdMustMatch: 'Las contraseñas deben coincidir',
      valEmailValid: 'Debes proporcionar un correo electrónico válido',
      valFileTypeError: 'El archivo debe ser un PDF o DOCX',
      valObjectivesRequired: 'Se debe seleccionar al menos 1 objetivo',
      valMustbeNumber: 'Se requiere número de accionistas',
      valNumberShareholders: 'El número de menores de edad debe ser menor que el de accionistas.',
      valMustZero: 'Debe ser mayor que cero',
      valAttetion: 'Atención',
      valStayTuned: 'Em breve!! ¡Fique atento!',
      valUnoDirector: 'Debe seleccionarse al menos 1 director',
      valMaxDirectors: 'El número máximo de consejeros es 8',
      valUnoShareholder: 'Se debe seleccionar al menos un accionista',
      valMaxShareholders: 'El número máximo de accionistas es 8',
      valTitleNotificion: 'Notificaciones',
      valSubtituloNotificacion: 'Sin notificaciones',
      valReadAll: 'Leer todos',
      valExpiryDate: 'Fecha de expiracion inválida. Tiempo mínimo de 6 meses a partir de hoy.',
      valIncorporationDateMinDate: 'La fecha de incorporación no debe ser inferior a 1 semana.',
      valMinAge: 'Debes tener al menos 18 años de edad',
      valInvalidDate: 'Formato de fecha inválido',
      valEnquirySelect: 'Se requiere investigación',
      valEnquiryMessage: 'Se requiere mensaje',
      valEnquiryMaxMessage: 'La descripción no puede tener más de 100 caracteres.',
      valRequiredJurisdictionStructure: 'Se debe seleccionar un tipo de empresa.',
      valRequiredJurisdictions: 'Se debe seleccionar al menos una jurisdicción.',
      valFieldsEmpty: 'Los campos obligatorios están vacíos.',
      valValidationFailed: 'La validación falló.'
    },

    errorMessage: {
      errMessAddRequest:
        'This service request is already open for this company, please check the On-Going tab to check the status',
      errMessStepRegisterShareholders: 'Aún no se han registrado todos los Accionistas.',
      errMessStepRegisterDirectors: 'Aún no se han registrado todos los Directores.',
      errMessStepRegisterMembers: 'Todos los Miembros aún no se han registrado',
      errMessUnexpected: 'Ocurrió un error inesperado. Por favor, inténtelo de nuevo.'
    },

    buttons: {
      btnBack: 'Atrás',
      btnRegister: 'Registrar',
      btnSave: 'Guardar',
      btnNext: 'Siguiente paso',
      btnSendMessage: 'Enviar un mensaje',
      btnSending: 'Enviando...',
      btnEdit: 'Editar',
      btnResetPwd: 'Restablecer contraseña',
      btnLogin: 'Iniciar sesión',
      btnContinueToCheckout: 'Continuar al pago',
      btnIgnoredCheckout: 'Saltar pago',
      btnLogOut: 'Cerrar sesión',
      btnGoToDashboard: 'Go to dashboard',
      btnGoBack: 'volver',
      btnResetPassWord: 'Restablecer la contraseña'
    },

    documents: {
      proofOfAddress: 'Comprobante de Domicilio',
      passport: 'Pasaporte',
      localDocument: 'Documento local (Identificación civil / Identificación / Licencia de Conducir / etc)',
      passportExpired: 'Pasaporte vencido (hace {{days}} días)',
      passportNearExpiry: 'Expira en {{days}} días',
      passportValid: 'Pasaporte válido (expira en {{days}} días)',
      passportExpiry: 'Vencimiento: {{date}}',
      uploadPassport: 'Subir pasaporte'
    },

    actions: {
      retry: 'Reintentar',
      refresh: 'Actualizar',
      clearFilters: 'Limpiar Filtros',
      markAsPaid: 'Marcar como Pagado',
      generateInvoice: 'Generar Factura',
      close: 'Cerrar',
      removeFilter: 'Remover filtro'
    },

    errors: {
      fetchBillingsFailed: 'Error al obtener datos de facturación',
      rateLimitExceeded: 'Demasiadas solicitudes en este momento. Por favor, espere unos segundos e intente nuevamente. Si el problema persiste, recargue la página.',
      invalidUserIdentification: 'Identificación de usuario inválida'
    },

    statuses: {
      paid: 'Pagado',
      pending: 'Pendiente',
      overdue: 'Vencido'
    },

    tooltips: {
      tltMinor: 'Número de menores que quieres',
      tltDirector:
        'Por favor, especifique la cantidad de directores que tiene la intención de nombrar. Incluso si planea contratar un director externalizado, aún puede nombrar sus propios directores.',
      tltShareholder: 'Introduzca el número total de shareholders.',
      tltShareholderMembers: 'Introduzca el número total de miembros.',
      tltLegalPersonality: 'Ofreceremos una estructura sugerida que podría satisfacer sus necesidades.',
      tltTotalValue:
        'Todos los cargos se realizarán en dólares estadounidenses. Consulte con su emisor de tarjeta de crédito para obtener más información sobre las tasas de cambio y las tarifas aplicables.',
      tltJurisdictions: 'Seleccione la jurisdicción de su preferencia en la lista de abajo.',
      corporateDirectorDescription: 'Incluir un director corporativo en la renovación anual de su empresa.'
    },

    // Otros
    others: {
      othCompanyName: 'Nombre de la empresa',
      othPreferredName: 'Nombre preferido',
      othSecondaryName: 'Nombre secundario',
      othOption1: 'Opción 1',
      othOption2: 'Opción 2',
      othOption3: 'Opción 3',
      othNameOptions: 'Opciones de nombre',
      othNoAccount: '¿No tienes una cuenta?',
      othForgotPwd: '¿Olvidaste la contraseña?',
      othResetPwdInstruction: 'Ingresa tu correo electrónico para recibir las instrucciones de restablecimiento de contraseña.',
      othChangePassword: 'Cambiar contraseña',
      othChangePasswordDescription: 'Por favor ingrese su nueva contraseña a continuación.',
      othProcessing: 'Procesando...',
      othPasswordChangedSuccess: '¡Contraseña cambiada exitosamente!',
      othHireCorpDirector: 'Quiero contratar a un director corporativo',
      othOrText: 'o',
      othPaymentSuccess: 'Pago efectuado con éxito',
      othPaymentFailed: 'Error making payment! Try again later.',
      othRegistering: 'Inscripción',
      othCompanies: 'Empresas',
      otheNewCompany: 'Nuevas Empresas',
      otheTransferredCompanies: 'Empresas transferidas',
      othCompany: 'Compañía',
      othDirectors: 'Director',
      othShareholders: 'Accionista',
      otheShareholdersAndDirectors: 'Directores y Accionistas',
      othCompanyDocuments: 'Documentos de la empresa',
      othBusiness: 'Negocio',
      othInformationYourNewCompany: 'Información de la Nueva Empresa',
      othIBCPrimaryNameTooltip: `
      Tenga en cuenta que su nombre preferido para la empresa puede no estar siempre disponible, ya que el nombre exacto o una variación muy similar puede estar ya en uso por outra entidade. Por ello, asegúrese de indicar a continuación el nombre preferido y dos alternativas, en orden de preferencia.El nombre de la empresa debe finalizar con “Limited” o “Ltd.”, así que verifique que esta terminación esté incluida al final de cada una de sus opciones de nombre.Asimismo, su empresa será constituida utilizando exactamente el nombre que aparezca a continuación. Por lo tanto, escriba el nombre exactamente como desea que figure en sus documentos corporativos.
      `,
      othIBCPrimaryName: 'Opción de nombre*',
      othIBCSecondName: 'Opción de segundo nombre*',
      othIBCThirdName: 'Opción de tercer nombre*',
      othActivityAddress: 'Dirección del director principal *',
      othMainCommercialAddress: 'Dirección Comercial Principal *',
      othPrimaryPhone: 'Teléfono Principal *',
      othPrimaryEmail: 'Correo Electrónico Principal *',
      othManagerAddress: 'Primera Dirección del Gerente *',
      othNumberOfUnits: 'Número de Unidades',
      othNumberOfUnitsTooltip:
        'Las unidades de participación (membership units) son fracciones de propiedad en una LLC, similares a las acciones de una sociedad. El número de unidades debe estar en un rango de 1 a 50.000.',
      othNumberOfSharesTooltip:
        'Las acciones representan la participación en la empresa. Indique cuántas acciones posee este accionista. El número de acciones debe estar en un rango de 1 a 50.000.',
      othMaxSharesUnits: 'El límite máximo es 50.000.',
      othCreationDate: 'Fecha de creación',
      othDoesTheCompanyConductRelevantActivities: '¿La empresa realiza actividades relevantes?*',
      othRelevantActivities: 'Actividades Relevantes',
      othNo: 'No',
      othYes: 'Sí',
      othSave: 'Ahorrar',
      othChooseRelevantActivity: 'Elige una actividad relevante *',
      othRelevantActivity: 'Actividad relevante',
      othChooseRelevantActivityTooltip:
        'Elija entre las opciones siguientes la que mejor se adapte al propósito de su offshore.',
      othShareCapital: 'Capital Social',
      othShareCapitalLess: 'Capital Social',
      othSelectRelevantActivity: 'Seleccione una actividad relevante',
      othTotalAuthorizedShares: 'Total de Acciones Autorizadas',
      othTotalAuthorizedSharesTooltip:
        'El total de acciones autorizadas es el número máximo de acciones que una empresa puede emitir según lo establecido en sus estatutos.',
      othParValue: 'Valor Nominal',
      othParValueTooltip:
        'El Valor Nominal de una Acción es el precio legal más bajo al que una empresa vende cada una de sus acciones.',
      othTotalIssuedShares: 'Total de Acciones Emitidas',
      othTotalIssuedSharesLess: 'Total de Acciones Emitidas',
      othNominalValue: 'Valor nominal por acción',
      othTotalIssuedSharesTooltip:
        'El total de acciones emitidas se refiere al número total de acciones que una empresa va a emitir al momento de su constitución.',
      othCurrency: 'Moneda *',
      othTotalAuthorizedUnits: 'Total de Unidades Autorizadas',
      othTotalIssuedUnits: 'Total de Unidades Emitidas',
      othSelectCurrency: 'Seleccione una moneda',
      othPushYourDocument: 'Envía tu documento',
      othOrSearchInYourComputer: 'O busca en tu computadora',
      othDocumentSupported: 'Documentos admitidos: PDF o DOC | Tamaño máximo: 30MB',
      othDashboard: 'Tablero de Control',
      othDashboardLogin: 'Acceso',
      othNatureOfBusiness: 'Naturaleza del Negocio (Sustancia Económica)',
      othCategory: 'Categoría',
      othDescription: 'Descripción',
      othDeclarationAndConfirmation: 'Declaración y Confirmación',
      othDeclarationText:
        'Al marcar la casilla a continuación, declaro y confirmo que toda la información proporcionada por mí en este sitio web es verdadera y correcta. Además, doy mi consentimiento y autorización para que la información contenida aquí se utilice con fines de registro en la jurisdicción elegida. Entiendo y acepto que cualquier información incorrecta o error causado por mi completar la información requerida en este sitio web puede resultar en un cargo para mí por presentar una enmienda en los documentos de la empresa offshore futura. Además, en caso de que se produzcan cambios en la información contenida aquí, informaré a Offshore2go en un plazo de siete (7) días hábiles.',
      othEntityObligedToLawsBahamas: 'La entidad está obligada a cumplir con todas las leyes y regulaciones de las Bahamas',
      othIDeclareAndConfirmAsAbove: 'Declaro y confirmo como se indica arriba.',
      othDocumentsWaitingForApproval: 'Documentos pendientes de aprobación',
      othApprovalsBehindSchedule: 'Aprobaciones atrasadas',
      othDocumentsMissingInfoFromCustomer: 'Documentos con información faltante del cliente',
      othDocumentsNewCompany: 'Documentos de la nueva empresa',
      othExpireProcess: 'Proceso de vencimiento',
      othFilterStatus: 'Filtrar estado',
      othPending: 'Pendiente',
      othPendingPayment: 'Pago pendiente',
      othRegisterOfNumbers: 'Total',
      othTotal: 'Total',
      othIncorporationFee: 'Tarifa de Incorporación',
      othGovernmentFee: 'Tarifa Gubernamental',
      othNotApproved: 'No Aprobado',
      othNoRegistrationNumber: 'No definido',
      othNoIncorporationDate: 'No definido',
      othPleaseProvideReason: 'Por favor, proporcione el motivo del rechazo',
      othEnterReason: 'Ingrese el motivo...',
      othEnterAdditionalDetails: 'Ingrese detalles adicionales...',
      othRejectDocument: 'Rechazar',
      othApproved: 'Aprobado',
      othRegister: 'Registro',
      othWaitingApproval: 'A la espera de la aprobación',
      othWaitingForMoreInfo: 'Esperando Más Información',
      othCreated: 'Creado',
      othConfirmed: 'Confirmado',
      othCompleted: 'Pagado',
      othRejected: 'Rechazado',
      othCanceled: 'Cancelado',
      othFailed: 'Fallido',
      othDocumentApproved: 'Documento Aprobado',
      othDocumentReproved: 'Documento no aprobado',
      othDocumentStatus: 'Estado del documento',
      othExpired: 'Caducado',
      othTypePaymentCredit: 'Tarjeta de Crédito',
      othTypePaymentDebit: 'Pago Débito',
      othPendingSignature: 'Firma pendiente',
      othRows: 'Filas',
      othApprovalDocuments: 'Aprobación de documentos',
      othCheckPreApprovedDocument: 'Verificar Documento Preaprobado',
      othSearch: 'Buscar',
      othSearchDocument: 'Buscar Documento',
      othSearchUsers: 'Buscar Usuarios',
      othUsers: 'Usuarios',
      othNewService: 'Nuevo Servicio',
      othScheduleSpecialist: 'Programar Especialista',
      othShareholder: 'Acionistas',
      othNewUser: 'Nuevo Usuario',
      othDetails: 'Detalles',
      othSelectPeriod: 'Seleccionar Periodo',
      othSearchCompany: 'Buscar Empresa',
      othMailroom: 'Sala de Correspondencia',
      othServiceConfig: 'Configuración de Servicio',
      othApproveCompany: 'Aprobar Empresa',
      othDocuments: 'Documentos',
      othDirector: 'Director(es)',
      othNumberOfShares: 'Número de Acciones*',
      othUnderages: 'Menores de Edad',
      othYear: 'Año',
      othMonth: 'Mes',
      othEnquiry: 'Support',
      othExceededTheShareLimit: 'Excedió el límite de acciones',
      othMinValue: 'El límite mínimo es 1.',
      othMaxValue: 'El límite máximo es 50.000.',
      othThreeNamesMustDiffer: 'Las tres opciones de nombre deben ser diferentes.',
      othRole: 'Rol',
      othBeneficialOwner: 'Beneficiario Beneficioso',
      othIndividualDirectors: 'Directores Individuales',
      othCompanyAdmin: 'Administración de la Empresa',
      othOrdinary: 'Ordinaria',
      othEditDirector: 'Editar Director',
      othMakeChangesProfile: 'Realice cambios en su perfil aquí. Haga clic en guardar cuando haya terminado.',
      othCompleteRegister: 'Registro completo',
      othStartApproval: 'Aprobación de inicio',
      othViewDocument: 'Ver información de la empresa',
      othVisualiseDocument: 'Ver información de la empresa',
      othModalRejected: 'Modal rechazado',
      othReasonForRejection: 'Motivo del rechazo',
      othComplementaryMessage: 'Mensaje complementario',
      othCancel: 'Cancelar',
      othModalApproved: 'Modal aprobado',
      othAreYouSureApprove: '¿Está seguro de que desea aprobar este documento?',
      othApprove: 'Aprobar',
      othMoreInfo: 'Solicite más información',
      othJune: 'Junio',
      othJuly: 'Julio',
      othComplete: 'Completo',
      othNameForAgent: 'Nombre',
      othEmailForAgent: 'Email',
      othAlternativeNames: 'Nombres alternativos',
      othDetailsKyc: 'Detalles de KYC',
      othOfTable: 'de',
      othAccordionItem: 'Acionista',
      othDirectorOption: 'directores',
      othCorporateDirectorOption: 'directores corporativos'
    },

    options: {
      optPronounSr: 'Sr.',
      optPronounSra: 'Sra.'
    },

    // Página de Criação de Conta
    OnboardingCreateAccountPageTitle: 'Crear cuenta',
    OnboardingCreateAccountLabelName: 'Nombre',
    OnboardingCreateAccountLabelLastName: 'Apellido',
    OnboardingCreateAccountLabelPronoun: 'Pronombre',
    OnboardingCreateAccountLabelEmail: 'Correo electrónico',
    OnboardingCreateAccountLabelPassword: 'Contraseña',
    OnboardingCreateAccountLabelConfirmPassword: 'Confirmar contraseña',
    OnboardingCreateAccountPlaceholderName: 'Ejemplo: Ariel',
    OnboardingCreateAccountPlaceholderLastName: 'Ejemplo: Souza',
    OnboardingCreateAccountPlaceholderPronoum: 'Seleccione su pronombre',
    OnboardingCreateAccountPlaceholderEmail: 'Ejemplo: Ariel@offshore2go.com',
    OnboardingCreateAccountPlaceholderPassword: 'Ejemplo: 123#!2',
    OnboardingCreateAccountPlaceholderConfirmPassword: 'Ejemplo: 123#!2',
    OnboardingCreateAccountSelectOptionsPronounSr: 'Sr.',
    OnboardingCreateAccountSelectOptionsPronounSra: 'Sra.',
    OnboardingCreateAccountErrorNameRequired: 'Rellene este campo',
    OnboardingCreateAccountErrorLastNameRequired: 'Rellene este campo',
    OnboardingCreateAccountErrorEmailRequired: 'Rellene este campo',
    OnboardingCreateAccountErrorEmailMustBe: 'Debe proporcionar un correo electrónico válido',
    OnboardingCreateAccountErrorPasswordRequired: 'Rellene este campo',
    OnboardingCreateAccountErrorConfirmPasswordRequired: 'Rellene este campo',
    OnboardingCreateAccountErrorPasswordRule:
      'Debe contener 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial.',
    OnboardingCreateAccountErrorConfirmPasswordMustMatch: 'Las contraseñas deben coincidir',
    OnboardingCreateAccountErrorFileSize: 'El archivo debe tener como máximo 3MB',
    OnboardingCreateAccountErrorFileType: 'El archivo debe ser un PDF o DOCX',
    OnboardingCreateAccountButtonNext: 'Siguiente',
    OnboardingCreateAccountButtonBack: 'Atrás',

    // Página de Definición de Objetivos
    OnboardingObjectivesPageTitle: 'Definir objetivos',
    OnboardingObjectivesLabelLegalPersonality: 'Personalidad jurídica',
    OnboardingObjectivesLabelMyObjects: 'Mis objetivos son',
    OnboardingObjectivesDefaultSelectOptionLegalPersonality: 'Seleccione una opción',
    OnboardingObjectivesSelectOptionLegalPersonalityIndividual: 'Individual',
    OnboardingObjectivesSelectOptionLegalPersonalityStartup: 'Startup',
    OnboardingObjectivesSelectOptionLegalPersonalityOperationalCompany: 'Compañía operativa',
    OnboardingObjectivesCheckBoxOptionMyObjectsFinancialInvestment: 'Inversión financiera',
    OnboardingObjectivesCheckBoxOptionMyObjectsBankAccount: 'Cuenta bancaria',
    OnboardingObjectivesCheckBoxOptionMyObjectsBrokers: 'Corredoras',
    OnboardingObjectivesCheckBoxOptionMyObjectsRealStateInTheUSA: 'Bienes raíces en EE. UU.',
    OnboardingObjectivesCheckBoxOptionMyObjectsRaiseCapitalFromInvestors: 'Recaudar capital de inversores',
    OnboardingObjectivesCheckBoxOptionMyObjectsPassThroughOperation: 'Operación de pase',
    OnboardingObjectivesCheckBoxOptionMyObjectsReceiveRevenuesFromCommercialTransactions:
      'Recibir ingresos de transacciones comerciales',
    OnboardingObjectivesCheckBoxOptionMyObjectsRoyalties: 'Regalías',
    OnboardingObjectivesSelectOptionErrorMustHave: 'Debe seleccionar al menos un objetivo',

    // Página de Justificación
    OnboardingJurisdictionPageTitle: 'Definir jurisdicción',
    OnboardingJurisdictionBahamasOptionTitle: 'Incorporar en las Bahamas',
    OnboardingJurisdictionBahamasOptionDescription: 'Director designado, sala de correo y dirección registrada',
    OnboardingJurisdictionBahamasOptionTitleWhyChoose: '¿Por qué elegir esto?',
    OnboardingJurisdictionBahamasOptionTextWhyChoose:
      'Esta es una instrucción para ti porque hemos ayudado a más de 1000 usuarios a crear offshores',
    OnboardingJurisdictionBahamasEDelawareOptionTitle: 'Incorporar en las Bahamas y Delaware',
    OnboardingJurisdictionBahamasEDelawareOptionDescription:
      'Director designado, sala de correo y dirección registrada',
    OnboardingJurisdictionBahamasEDelawareOptionTextWhyChoose:
      'Nuestro equipo con 25 años de experiencia ha ayudado a más de 1,000 usuarios a establecer compañías en las Bahamas, Islas Caimán, Belice y Delaware, entre otras jurisdicciones.',
    OnboardingJurisdictionCaimanEDelawareOptionTitle: 'Incorporar en las Islas Caimán y Delaware',
    OnboardingJurisdictionCaimanEDelawareOptionDescription: 'Director designado, sala de correo y dirección registrada',
    OnboardingJurisdictionCaimanEDelawareOptionTextWhyChoose:
      'Nuestro equipo con 25 años de experiencia ha ayudado a más de 1,000 usuarios a establecer compañías en las Bahamas, Islas Caimán, Belice y Delaware, entre otras jurisdicciones.',

    // Página de Directores
    OnboardingDirectorsInstructionCardDescription: 'Nulo',
    OnboardingDirectorsInstructionCardTitle: 'Instrucción para ti',
    OnboardingDirectorsLabelNumberOfDirectors: 'Número de directores',
    OnboardingDirectorsOptionHireCorporateDirector: 'Quiero contratar un director corporativo',
    OnboardingDirectorsPageTitle: '¿Cuántos directores tendrá su empresa offshore?',
    OnboardingDirectorsTextOr: 'O',
    OnboardingDirectorsTooltipNumberOfDirectors: 'Número de directores que deseas',

    // Página de Accionistas
    OnboardingShareholdersInstructionCardDescription: 'Nulo',
    OnboardingShareholdersInstructionCardTitle: 'Nulo',
    OnboardingShareholdersLabelNumberOfMinors: 'Número de menores de edad',
    OnboardingShareholdersLabelNumbersOfshareholders: 'Número de accionistas',
    OnboardingShareholdersPageShareholderTitle: '¿Cuántos accionistas tendrás?',
    OnboardingShareholdersPageUnderageTitle: '¿Cuántos accionistas menores de edad tendrás?',
    OnboardingShareholdersTooltipNumberOfMinors: 'Número de menores de edad',
    OnboardingShareholdersTooltipNumbersOfshareholders: 'Número de accionistas',

    // Página de Complementos
    OnboardingAddonsLabelSelectAddons: 'Seleccione servicios adicionales',
    OnboardingAddonsOptionBasicAccounting: 'Contabilidad básica',
    OnboardingAddonsOptionDigitalMailRoom: 'Sala de correo digital',
    OnboardingAddonsOptionFinancialStatement: 'Estado financiero',
    OnboardingAddonsOptionPremiumAccountingServices: 'Servicios de contabilidad premium',
    OnboardingAddonsOptionRegisterAddress: 'Dirección registrada',
    OnboardingAddonsOptionYearlyReviewOfStructure: 'Revisión anual de la estructura',
    OnboardingAddonsPageDescription: 'No se preocupe, puede cambiar sus preferencias en cualquier momento',
    OnboardingAddonsPageTitle: 'Seleccione servicios adicionales',

    // Onboarding Request Page
    OnboardingRequestInitPage: 'Sus solicitudes',
    OnboardingRequestWhatDoNeed: '¿Qué necesito?',
    OnboardingRequestProcessingTime: 'Tiempo de procesamiento',
    OnboardingRequestPrice: '€',
    OnboardingRequestActionSubmit: 'Crear una nueva solicitud',
    OnboardingRequestActionCheckout: 'Continuar a la comprobación',
    OnboardingRequestStepsToExpect: 'Pasos a esperar',
    OnboardingRequestLoadingData: 'Cargando...',
    OnboardingRequestCompleteRequest: 'Completa tu solicitud',
    OnboardingRequestNoData: 'No hay ninguna solicitud en curso',
    OnboardingRequestFailed: 'Solicitud fallida',
    OnboardingRequestList: 'Lista de solicitudes',
    CLName: 'Nombre',
    CLCompanyName: 'Nombre de la empresa',
    CLEmail: 'Email',
    CLCreated: 'Creado',
    CLValue: 'Valor',
    CLNumberRegister: 'Registro de Números',
    CLTitle: 'Título',
    CLStatus: 'Status',
    OnboardingDownloadDocument: 'Descarga del certificado',
    // Página de Resumen
    OnboardingSummaryButtonContinueToCheckout: 'Continuar para el pago',
    OnboardingSummaryPageTitle: 'Resumen de su compra',

    // Página de Pago Exitoso
    PaymentSucceddedTitle: '¡Pago exitoso!',
    PaymentSucceddedSubTitle: '¡Pago exitoso!',
    GoToDashboard: 'Ir al panel',

    PaymentProcessingTitle: 'Confirmación de pago',
    PaymentProcessingDescription: 'Espere mientras confirmamos su pago...',

    // Outros
    OthersSelectYourOption: 'Seleccione una opción',
    OthersOptionsSelect: 'Otras...',
    PackageTitle: 'Su paquete - ',
    Required: 'Requerido',
    ContinueToCheckout: 'Continuar para finalizar la compra',
    checkoutIsSecureTitle: 'Serás redirigido a un ambiente seguro.',
    Annual: 'Anual',
    checkoutIsSecureText:
      'Estamos comprometidos con la seguridad de su información y queremos asegurarnos de que su experiencia de pago sea completamente confiable. Al hacer clic en el botón a continuación, será redirigido al entorno de pago seguro de Stripe, una plataforma reconocida internacionalmente por sus protocolos de seguridad de alto nivel.',
    othersTextCharacter: 'Characters',
    PendingPaymentSelectCompany:
      'Aún no hemos identificado el pago de su solicitud. Acceda a la página de pago y complete el pago para continuar con la apertura de su Offshore.',
    BtnPendingPaymentSelectCompany: 'Continuar al pago',
    BtnCreateNewOffshore: 'crear nueva costa afuera',

    // Alert Messages
    AlertEnquiryMessage: 'El tamaño máximo de archivo es 5MB. Inténtalo de nuevo',
    AlertFinishYourRegisterTitle: '¡Felicidades!',
    AlertFinishYourRegisterMessage:
      'A partir de ahora puedes relajarte — Offshore2go se encargará de todo y en 7 días tu empresa estará abierta.',
    AlertFinishYourRegisterButton: 'Entendido',
    AlertContractTitle: 'Firma el contrato de usuario',
    // Transfer Company
    companyTransfer: {
      othTitlePageDirectors: 'Por favor inserte la información de los directores',
      othTitlePageShareholders: 'Por favor inserte la información de los accionistas',
      othTllCompanyRegistering: 'Por favor cuéntenos más sobre su empresa',
      othCompanyName: 'Nombre de la empresa',
      othNumberRegisterCompany: 'Número de registro de la compañía',
      othCompleteCompanyRegistration: 'Registro completo de la empresa',
      othJuridiction: 'Jurisdicción*',
      othUpladoDocument: 'Certificado de incorporación',
      othSelectJurisdiction: 'Seleccionar jurisdicción',
      othCheckCompanyDocument: 'Quiero que Offshore2go recupere los documentos de mi empresa',
      othNumberShareholders: 'Número de accionistas',
      othNumberDirectors: 'Número de directores',
      othTotalAuthorizedShares: 'Total de acciones autorizadas*',
      othTotalIssuedShares: 'Total de acciones emitidas',
      othParValue: 'Valor nominal',
      othCurrency: 'Divisa',
      othSelectedCurrency: 'Seleccionada divisa',
      othComplementTransfer: 'Complementar',
      othWarningRegisterCompany: 'Puedes pasar al siguiente, este ya se ha completado.',
      othWarningDontRegisterCompany: 'Puedes pasar al siguiente, no es necesario que rellenes estos datos.',
      othModalTitleInformation: '¿Cómo Offshore2go recupera mis documentos?',
      othModalInformation:
        'Puede ahorrar tiempo pagando una pequeña tarifa, por lo que no necesita cargar todos los documentos de su empresa.',
      descriptionText: 'Certificado de Incorporación'
    },
    certificatesDocuments: {
      CERTIFICATE_INCORPORATION: 'Certificado de Incorporación',
      FIRST_DIRECTORS_RESOLUTION: 'Primera Resolución de los Directores',
      ACCOUNTING_DECLARATION: 'Declaración Contable',
      FORM_D: 'Formulario D (Partes Controladoras)',
      SEAL_COPY: 'Copia del Sello de la Empresa',
      MEMORANDUM_ASSOCIATION: 'Memorando de Asociación',
      REGISTER_MEMBERS: 'Registro de Socios',
      REGISTER_DIRECTORS: 'Registro de Directores',
      CERTIFICATE_SHARES: 'Certificado de Acciones',
      CERTIFICATE_COMPLIANCE: 'Certificado de Cumplimiento',
      'Certificate of Shares': 'Certificado de Acciones',
      ARTICLES_ASSOCIATION: 'Estatutos de la Empresa',
      Accounting: 'Contabilidad',
      Alterações: 'Cambios',
      Certificados: 'Certificados',
      Certificates: 'Certificados',
      Changes: 'Modificaciones',
      Constituição: 'Constitución',
      Contabilidade: 'Contabilidad',
      Forms: 'Formularios',
      Formulários: 'Formularios',
      Incorporation: 'Constitución',
      'Other Documents': 'Otros documentos'
    },
    jurisdictionTitles: {
      bahamas: 'BAHAMAS'
    },
    accountingModule: {
      welcomeAccounting:
        '¡Bienvenido al módulo de Contabilidad! Aquí puedes ver toda la información de tus transacciones, conectar tu cuenta bancaria para recuperar el historial de movimientos, agregar transacciones manuales, generar un balance general y enviarlo a la revisión de un agente contable.',
      addManualTransactions: 'Agregar transacciones manuales',
      selectBank: 'Seleccionar banco',
      connectYourBank: 'Conecta tu banco',
      titleConnectBank:
        'Serás redirigido al sitio web de Plaid, donde podrás registrarte y conectar tu cuenta bancaria preferida.',
      infoConnectBank: 'Offshore2Go podrá: ',
      goConnectBank: ' Leer el historial de transacciones',
      btnConnectManual: 'Agregar banco manualmente',
      btnConnectPlaid: 'Conectar con Plaid',
      categoryList: 'Categoría',
      searchCategories: 'Buscar categorías...'
    },
    billingPayments: {
      billingPaymentsSubtitle: 'Visualice y administre sus pagos y facturas',
      billingPaymentsTitle: 'Facturación y Pagos',
      billingPaymentsFilterDescription: 'Filtre sus transacciones',
      billingPaymentsSearchPlaceholder: 'Buscar transacción',
      billingPaymentsDescription: 'Descripción',
      billingPaymentsAmount: 'Monto',
      billingPaymentsDate: 'Fecha',
      billingPaymentsPaymentMethod: 'Método de pago',
      billingPaymentsStatus: 'Estado',
      billingPaymentsType: 'Tipo'
    },
    enquiry: {
      enquirySubtitle: 'Contáctenos y haga sus preguntas',
      enquiryMessagePlaceholder: 'Escriba su mensaje aquí...'
    },
  accounting: {
    accountingSubtitle: 'Administre sus transacciones y categorías financieras',
    period: 'Período',
    open: 'Abierto',
    days: 'días',
    leftToEndMonth: 'restantes para el fin del mes',
    output: 'Salida',
    input: 'Entrada',
    noCategory: 'Sin categoría',
    noTransactionsYet: 'Ninguna transacción registrada todavía',
    featureComingSoon: 'Esta funcionalidad estará disponible pronto'
  },
    KYCDocuments: {
      statusKYC: {
        blocked: 'Rechazado',
        pending: 'Pendiente',
        approved: 'Aprobado'
      },
      detailsKYC: {
        Enforcements: 'Aplicación de Regulaciones',
        PEPs: 'Personas Expuestas Políticamente (PEPs)',
        Source: 'Fuente',
        Country: 'País',
        SubCategories: 'Subcategorías',
        GoverningRole: 'Rol Gobernante',
        ExpirationDate: 'Fecha de Expiración'
      },
      notFound: 'No hay restricciones para esta persona.'
    },
    annualFee: {
      title: 'Configuración de la tarifa anual (por jurisdicción y tipo de empresa)',
      loading: 'Cargando...',
      error: 'Error al buscar configuraciones.',
      noConfig: 'No se encontró ninguna configuración.',
      companyType: 'Tipo de empresa',
      amount: 'Valor',
      tooltipAmountMin: 'No puede establecer el valor por debajo del mínimo actualmente mostrado para esta configuración.',
      dueDate: 'Fecha de vencimiento',
      description: 'Descripción',
      save: 'Guardar',
      saving: 'Guardando...',
      saved: '¡Guardado!',
      saveError: 'Error al guardar.',
      companyTypes: {
        new_company: 'Nueva Empresa',
        transfer_company: 'Transferencia de Empresa'
      }
    },
    preferences: {
      subtitle: 'Administra la configuración y preferencias de tu cuenta',
      profileSettings: 'Configuración de Perfil',
      security: 'Seguridad',
      profileInformation: 'Información del Perfil',
      profileDescription: 'Los detalles personales de tu cuenta',
      accountMember: 'Usuario',
      fullName: 'Nombre Completo',
      emailAddress: 'Dirección de Correo',
      notProvided: 'No proporcionado',
      languagePreferences: 'Preferencias de Idioma',
      chooseLanguage: 'Elige tu idioma preferido',
      languageUpdated: 'Idioma actualizado exitosamente',
      updatePasswordDescription: 'Actualiza tu contraseña para mantener tu cuenta segura',
      enterNewPassword: 'Ingresa nueva contraseña',
      confirmNewPassword: 'Confirma nueva contraseña',
      passwordRequirements: 'La contraseña debe contener al menos 8 caracteres, incluyendo mayúsculas, minúsculas, números y caracteres especiales.'
    }
  }
};

export default translate_es;
